import { Navigate } from "react-router-dom";

interface PrivateRouteProps {
  element: JSX.Element;
  token: string | null;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element, token }) => {
  return token ? element : <Navigate to="/auth/signin" replace />;
};

export default PrivateRoute;
